import { Box, Card, CardContent, ListItemButton, Stack, Typography } from "@mui/material";
import { act, forwardRef, useState } from "react";
import styles from './UserItem.module.css';
import { AddLink, Block, DeleteOutlined, Done, HourglassTop, HowToReg, ManageAccounts } from "@mui/icons-material";
import { IconButton } from "components/buttons";
import { ConfirmationDialog } from "components/dialogs";

const UserItem = forwardRef(({ selected, id, name, grants, onSelect, disabled, activated, onBlock, onDelete }, ref) => {
  
  const [openBlockDialog, setOpenBlockDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const blockHandler = (formJson) => { 
    onBlock(id, !disabled);
    setOpenBlockDialog(false);
  };
    
  const deleteHandler = (formJson) => {
    onDelete(id);
    setOpenDeleteDialog(false);
  }

  const cancelBlockHandler = (e) => { 
    e.stopPropagation();
    setOpenBlockDialog(false);
  };

  const cancelDeleteHandler = (e) => { 
    e.stopPropagation();
    setOpenDeleteDialog(false);
  };

  return (
    <ListItemButton
        ref={ref}
        sx={{
            pr:1, pb: 1, pl:0, pt: 0, flexGrow: 1,               
            '& :hover.MuiPaper-root':{
                backgroundColor: 'rgb(248, 248, 238) !important'
            },
            '&.Mui-selected .MuiCard-root': {
                backgroundImage: 'unset',
                backgroundColor: 'aliceblue'
            }
        }}
        className={"pagelist-item " + (disabled ? 'disabled' : '')}
        selected={selected}
    >
      <Card 
          sx={{width:'100%'}} 
          onClick={(e) => onSelect({id, name, grants, disabled, activated})}
      >
        <CardContent sx={{padding: '0px 0px 0px 8px !important'}}>
          <Stack className={styles.nameWrapper} direction='row' sx={{alignItems: 'center'}}>
            <ManageAccounts color='secondary' sx={{mr: 1, fontSize: 28}}/>
            <Box m={1} sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '60%'}}>
              <Typography className={styles.name} sx={{mr: 1}}>{name}</Typography>
            </Box>
            <Stack className={styles.infoWrapper} direction="row" alignItems="center" justifyContent="flex-end">
              <Box sx={{display: 'flex', flexDirection: 'column', my: 1, mr: 1, flexGrow: 1}}>
                <Stack direction='row' sx={{alignItems: 'center'}}>
                  {activated ? <HowToReg fontSize='small' color='action' sx={{mr: 1}}/> : <HourglassTop fontSize='small' color='action' sx={{mr: 1}}/> }
                  <div>{activated ? 'Активирован' : 'Не активирован'}</div>
                </Stack>
                <Stack direction='row' sx={{alignItems: 'center'}}>
                  {disabled ? <Block fontSize='small' color='action' sx={{mr: 1}}/> : <Done fontSize='small' color='action' sx={{mr: 1}}/> }
                  <div>{disabled ? 'Заблокирован' : 'Активен'}</div>
                </Stack>
              </Box>
              <IconButton
                handler={(e) => {
                  e.stopPropagation();
                  //if(!isSelected) onSelect(makeItem());
                  //setOpen(true);
                }}
                text={!activated ? 'Отправить на почту ссылку для активации ещё раз' : ''}
                disabled={activated}
                iconCmp={<AddLink className='blue-button'/>}
              />
              <IconButton
                handler={(e) => {
                  e.stopPropagation();
                  setOpenBlockDialog(true);
                }}
                text={disabled ? 'Разблокировать пользователя' : 'Заблокировать пользователя'}
                iconCmp={disabled ? <Done className='delete-button'/> : <Block className='delete-button'/>}
              />
              <ConfirmationDialog
                  title={disabled ? 'Разблокировать' : 'Заблокировать'}
                  text={<span>{disabled ? 'Разблокировать' : 'Заблокировать'} пользователя <b>{name}</b>?</span>}
                  open={openBlockDialog}
                  onOk={blockHandler}
                  onCancel={cancelBlockHandler}
                  stopClickPropagation
              />
              <IconButton
                handler={(e) => {
                  e.stopPropagation();
                  setOpenDeleteDialog(true);
                }}
                text='Удалить пользователя'  
                iconCmp={<DeleteOutlined className='delete-button'/>}
                sx={{marginRight: '8px'}}
              />
              <ConfirmationDialog
                  title="Удалить"
                  text={<span>Удалить пользователя <b>{name}</b>?</span>}
                  open={openDeleteDialog}
                  onOk={deleteHandler}
                  onCancel={cancelDeleteHandler}
                  stopClickPropagation
              />
              
          </Stack>
          </Stack> 
        </CardContent>
      </Card>
    </ListItemButton>
  );
});

export default UserItem;    